import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { PrimaryHeader, SecondaryHeader, NavBackButton, BackIcon } from '../styles/global'
import { submitSymptom } from '../utils/api.utils'
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';

interface Props {
  symptom: any
  simulation?: any | undefined
  shouldDisplay: any
  fetchSymptoms: any
}

export function SymptomEditor({ symptom, simulation, shouldDisplay, fetchSymptoms }: Props) {
  const [currentSymptom, setSymptom] = useState(symptom);

  const isValid = currentSymptom.name !== ''

  useEffect(() => {
    setSymptom((targetSymptom: any) => ({
      ...targetSymptom,
      name: targetSymptom.name || '',
      label: targetSymptom.label || '',
      description: targetSymptom.description || '',
      url: targetSymptom.url || ''
    }))
  }, []);

  function saveSymptom() {
    submitSymptom(currentSymptom)
      .then((response: any) => {
        fetchSymptoms()
        shouldDisplay(false)
        return response
      }).catch((err: any) => console.error(err))
  }

  const handleChange = (field: string, value: string) => {
    setSymptom((current: any) => ({ ...current, [field]: value }))
  }

  return (
    <EditorWrapper>
      <EditorHeader>
        <NavBackButton startIcon={<BackIcon />} onClick={() => shouldDisplay(false)}>
          Back to Symptoms
        </NavBackButton>
        <PrimaryHeader style={{ margin: 0 }}>
          {currentSymptom.id ? 'Edit Symptom' : 'New Symptom'}
        </PrimaryHeader>
      </EditorHeader>

      <SectionWrapper>
        <SecondaryHeader>General Information</SecondaryHeader>
        <FormCard>
          <FieldGroup>
            <Label>Symptom Name *</Label>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="e.g. Cough"
              value={currentSymptom.name || ""}
              onChange={(e) => handleChange('name', e.target.value)}
            />
          </FieldGroup>
          <FieldGroup>
            <Label>Display Label</Label>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="e.g. Dry Cough"
              value={currentSymptom.label || ""}
              onChange={(e) => handleChange('label', e.target.value)}
            />
          </FieldGroup>
        </FormCard>
      </SectionWrapper>

      <SectionWrapper>
        <SecondaryHeader>Detailed Information</SecondaryHeader>
        <FormCard>
          <FieldGroup>
            <Label>Description</Label>
            <TextField
              fullWidth
              multiline
              minRows={4}
              variant="outlined"
              placeholder="Describe the clinical presentation..."
              value={currentSymptom.description || ""}
              onChange={(e) => handleChange('description', e.target.value)}
            />
          </FieldGroup>
          <FieldGroup>
            <Label>Learn More URL (Optional)</Label>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="https://..."
              value={currentSymptom.url || ""}
              onChange={(e) => handleChange('url', e.target.value)}
            />
          </FieldGroup>
        </FormCard>
      </SectionWrapper>

      <FabWrapper
        variant="extended"
        color="primary"
        disabled={!isValid}
        onClick={() => saveSymptom()}
      >
        SAVE SYMPTOM
      </FabWrapper>
    </EditorWrapper>
  );
}

const EditorWrapper = styled.div`
  width: 100%;
  margin: 0;
  padding-bottom: 50px;
`;

const EditorHeader = styled.div`
  margin-bottom: 40px;
`;



const SectionWrapper = styled.div`
  margin-bottom: 40px;
`;

const FormCard = styled.div`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
`;

const FieldGroup = styled.div`
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const FabWrapper = styled(Fab)`
  && {
    position: fixed;
    right: 40px;
    bottom: 40px;
    background-color: #3f51b5;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    padding: 0 32px;
    box-shadow: 0 10px 15px -3px rgba(63, 81, 181, 0.4);
    &:hover {
      background-color: #303f9f;
    }
  }
`;
